var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatePickerPopUpWarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 22.3926C17.6964 22.3926 22.3135 17.7755 22.3135 12.0801C22.3135 6.38464 17.6964 1.76758 12.001 1.76758C6.30554 1.76758 1.68848 6.38464 1.68848 12.0801C1.68848 17.7755 6.30554 22.3926 12.001 22.3926Z",
    stroke: "#F6BB42",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 10.0176V17.5801",
    stroke: "#F6BB42",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 7.26758C12.5705 7.26758 13.0322 6.80587 13.0322 6.23633C13.0322 5.66678 12.5705 5.20508 12.001 5.20508C11.4314 5.20508 10.9697 5.66678 10.9697 6.23633C10.9697 6.80587 11.4314 7.26758 12.001 7.26758Z",
    fill: "#F6BB42"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePickerPopUpWarningIcon);
export default __webpack_public_path__ + "static/media/DatePickerPopUpWarningIcon.b29839a6.svg";
export { ForwardRef as ReactComponent };